var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { g, anchors } from '@joint/plus';
var mapping = function (view, magnet, ref) {
    var anchor;
    var model = view.model;
    var bbox = view.getNodeUnrotatedBBox(magnet);
    var center = model.getBBox().center();
    var angle = model.angle();
    var side = model.getItemSide(view.findAttribute('item-id', magnet));
    if (side === 'left') {
        anchor = bbox.leftMiddle();
    }
    else if (side === 'right') {
        anchor = bbox.rightMiddle();
    }
    else {
        var refPoint = ref;
        if (ref instanceof Element) {
            var refView = this.paper.findView(ref);
            refPoint = (refView) ? refView.getNodeBBox(ref).center() : new g.Point();
        }
        refPoint.rotate(center, angle);
        anchor = (refPoint.x <= (bbox.x + bbox.width / 2)) ? bbox.leftMiddle() : bbox.rightMiddle();
    }
    return anchor.rotate(center, -angle);
};
export var anchorNamespace = __assign({}, anchors);
Object.assign(anchorNamespace, {
    mapping: mapping
});
